import React, { useState } from 'react';

import { Card, Icon, Separator, Text, VStack } from '@betterment/samba-react';
import { Button } from '@betterment/style-closet-react';

import LockedAccountModal from './LockedAccountModal';

const LockedManageAccount: React.FC<React.PropsWithChildren<unknown>> = () => {
  const [shouldShowLockedModal, setShowLockedModal] = useState(false);
  const closeHandler = () => {
    setShowLockedModal(false);
  };
  return (
    <>
      <Card css={{ px: 'space.300', mb: 'space.200' }}>
        <Card.Header css={{ py: 'space.300' }}>
          <Text
            as="p"
            css={{
              fontSize: 'fontSize.200',
              fontWeight: 'medium',
              margin: 'space.0',
            }}
          >
            Manage account
          </Text>
        </Card.Header>
        <Separator />
        <Card.Content css={{ py: 'space.300' }}>
          <VStack css={{ alignItems: 'center' }}>
            <Icon name="Lock" size="small" color="icon.critical" />
            <Text
              as="p"
              css={{
                textAlign: 'center',
                py: 'space.200',
                mb: 'space.200',
                _last: { mb: 'space.0' },
              }}
            >
              You won't be able to take action on your Checking account until we unlock it.
            </Text>
            <Button variant="tertiary" onClick={() => setShowLockedModal(true)}>
              Learn more
            </Button>
          </VStack>
        </Card.Content>
      </Card>
      {shouldShowLockedModal && <LockedAccountModal closeHandler={closeHandler} />}
    </>
  );
};

export default LockedManageAccount;
